// Aplica o visual do tema da loja (vindo do bloco do tema via query string)
// nos tokens CSS do portal. Guardado na sessão porque a navegação interna
// troca a URL e perde a query original.
const KEY = "checkstore-portal-theme";
const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

function readable(hex) {
  const value = hex.length === 4 ? hex.replace(/^#(.)(.)(.)$/, "#$1$1$2$2$3$3") : hex;
  const [r, g, b] = [1, 3, 5].map((i) => parseInt(value.slice(i, i + 2), 16) / 255);
  const lum = (c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);
  const luminance = 0.2126 * lum(r) + 0.7152 * lum(g) + 0.0722 * lum(b);
  return luminance > 0.45 ? "#1c1917" : "#ffffff";
}

export function resolveBrandTheme(search, stored) {
  const params = new URLSearchParams(search || "");
  const theme = { ...(stored || {}) };
  const accent = params.get("accent");
  const radius = Number(params.get("radius"));
  const font = params.get("font");
  if (accent && HEX.test(accent)) theme.accent = accent;
  if (Number.isFinite(radius) && params.has("radius")) theme.radius = Math.min(Math.max(radius, 0), 24);
  if (font && /^[\w\s,'"-]{1,80}$/.test(font)) theme.font = font;
  return theme;
}

export function applyBrandTheme(win = window) {
  let stored;
  try {
    stored = JSON.parse(win.sessionStorage.getItem(KEY) || "null");
  } catch {
    stored = null;
  }
  const theme = resolveBrandTheme(win.location.search, stored);
  try {
    win.sessionStorage.setItem(KEY, JSON.stringify(theme));
  } catch {
    /* sessionStorage indisponível em alguns iframes */
  }
  const root = win.document.documentElement.style;
  if (theme.accent) {
    root.setProperty("--color-accent", theme.accent);
    root.setProperty("--color-accent-hover", theme.accent);
    root.setProperty("--color-accent-text", readable(theme.accent));
    root.setProperty("--color-focus", `${theme.accent}40`);
  }
  if (theme.radius != null) {
    root.setProperty("--radius-sm", `${Math.round(theme.radius * 0.66)}px`);
    root.setProperty("--radius-md", `${theme.radius}px`);
    root.setProperty("--radius-lg", `${Math.round(theme.radius * 1.5)}px`);
  }
  if (theme.font) {
    root.setProperty("--font-sans", `${theme.font}, "Inter", system-ui, -apple-system, sans-serif`);
  }
  return theme;
}
